import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-52f62324"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner-content" }
const _hoisted_2 = { style: {"white-space":"normal"} }
const _hoisted_3 = {
  key: 1,
  style: {"height":"20px","width":"100%"}
}
const _hoisted_4 = { class: "modal__container" }


import {
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonButton,
} from '@ionic/vue';
import { closeOutline } from 'ionicons/icons';

interface Props {
  isOpened: boolean;
  title?: string;
  isHideClose?: boolean;
  isNotCloseOutside?: boolean;
  isMobileCenter?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    isOpened: { type: Boolean },
    title: {},
    isHideClose: { type: Boolean },
    isNotCloseOutside: { type: Boolean },
    isMobileCenter: { type: Boolean, default: true }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    class: _normalizeClass(['modal', { 'modal--mobile-center': props.isMobileCenter }]),
    "is-open": props.isOpened,
    "can-dismiss": !_ctx.isNotCloseOutside,
    onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.title || !props.isHideClose)
          ? (_openBlock(), _createBlock(_unref(IonToolbar), { key: 0 }, {
              default: _withCtx(() => [
                (props.title)
                  ? (_openBlock(), _createBlock(_unref(IonTitle), { key: 0 }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(props.title), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!props.isHideClose)
                  ? (_openBlock(), _createBlock(_unref(IonButtons), {
                      key: 1,
                      slot: "end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonButton), {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3)),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _: 3
  }, 8, ["class", "is-open", "can-dismiss"]))
}
}

})